import { InfoIcon } from 'src/shared/icons/Icons'
import styled from 'styled-components'

export const GridTooltipInfoIconStyled = styled(InfoIcon)`
  font-size: 1.25rem;
  margin-left: ${({ theme }) => theme.spacing(1)};
`
